export default __webpack_public_path__ + "resources/icons/n421-21a6.png";